import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-b border-steelLine bg-charcoal px-4 py-8 sm:py-10" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-2xl rounded-lg border border-gold/40 bg-steel p-4 text-center" data-id="element-74" data-mp="223el1k29z72x">
        <ShieldCheckIcon className="mx-auto h-8 w-8 text-gold" aria-hidden="true" data-id="element-75" data-mp="1x4bq4sg0eh8o" />
        <h2 className="mt-1.5 text-lg text-white sm:text-2xl" data-id="element-76" data-mp="1x2ijhd5ebx0o">Your Purchase Is 100% Protected</h2>
        <div className="mt-2 space-y-1.5 text-sm font-medium leading-snug text-lightGray" data-id="element-77" data-mp="19cegn80181aq">
          <p data-id="element-78" data-mp="14dl2regu28a1">Try METAL FABRICATION READY™ for 14 days.</p>
          <p data-id="element-79" data-mp="1j5lulh8u8pmf">
            Explore the collection, project categories, fabrication plans, measurements, references and included
            bonuses.
          </p>
          <p data-id="element-80" data-mp="qo9geail2ygo">
            If you decide the collection isn&apos;t right for you, contact us within 14 days for a full refund according
            to the refund terms.
          </p>
        </div>
        <p className="mt-2.5 font-display text-xs font-extrabold uppercase tracking-wide text-gold sm:text-sm" data-id="element-81" data-mp="ozjcam7qheq7">
          Simple. Secure. Risk-Free.
        </p>
      </div>
    </section>;
}